import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useTranslation } from "react-i18next";

import { AccessRequestsPage } from "./access_requests_page";
import { useAccessRequestPage } from "./use_access_requests_page";

export const AccessRequestsController = () => {
  const { t } = useTranslation(["admin", "translation"]);
  const { accessRequests, isInitialLoading, isFetching, error, setPage } = useAccessRequestPage();

  const WrappedAccessRequestsPage = usePageWrapper(AccessRequestsPage);

  return (
    <WrappedAccessRequestsPage
      loading={isInitialLoading}
      errors={error}
      errorComponent={
        <NotFoundComponent
          message={t("admin:accessRequests.pageCouldNotBeLoaded")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/admin/access_requests"
        />
      }
      accessRequests={accessRequests}
      setPage={setPage}
      isFetching={isFetching}
    />
  );
};
